import { MessageSquarePlus } from "lucide-react";
import { useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";

import { CommunicationDialog } from "@platform/features/communication/communication-dialog";

export function FeedbackDialog({ labelClassName }: { labelClassName: string }) {
	const t = useTranslations("feedback");
	return (
		<CommunicationDialog
			type="feedback"
			ns="feedback"
			trigger={
				<Button variant="ghost" size="sm" className="h-9 w-full justify-start gap-3 text-xs">
					<MessageSquarePlus className="text-muted-foreground size-4 shrink-0" />
					<span className={labelClassName}>{t("trigger")}</span>
				</Button>
			}
		/>
	);
}
